(() => {
  if (window.__divanoAfterpaySync) return;
  window.__divanoAfterpaySync = true;

  document.addEventListener('variant:update', (event) => {
    const detail = event.detail || {};
    const html = detail.data && detail.data.html;
    const variant = detail.resource;
    const target = event.target instanceof Element ? event.target : null;
    const scope = target
      ? target.closest('.quick-add-modal__content') || target.closest('.shopify-section')
      : document;
    if (!scope) return;
    const placements = scope.querySelectorAll('square-placement[id]');
    if (!placements.length) return;

    placements.forEach((el) => {
      let amount = null;
      if (html && typeof html.getElementById === 'function') {
        const fresh = html.getElementById(el.id);
        if (fresh) amount = fresh.getAttribute('data-amount');
      }
      if (!amount && variant && variant.price != null && Number.isFinite(Number(variant.price))) {
        amount = (Number(variant.price) / 100).toFixed(2);
      }
      if (amount && amount !== el.getAttribute('data-amount')) {
        el.setAttribute('data-amount', amount);
      }
    });
  });
})();
